const cleanText = (value) => (value == null ? "" : String(value).trim());

export const buildSunatFileName = ({ ruc, tipo, periodo, extension = "txt" }) => {
  const normalizedRuc = cleanText(ruc).replace(/[^0-9]/g, "") || "20609212102";
  const normalizedTipo = cleanText(tipo).toUpperCase();
  const normalizedPeriodo = cleanText(periodo).replace(/-/g, "").slice(0, 6);

  if (normalizedTipo === "RVIE" || normalizedTipo === "140400") {
    return `LE${normalizedRuc}${normalizedPeriodo}00140400001111.${extension}`;
  }
  if (normalizedTipo === "RCE" || normalizedTipo === "080400") {
    return `LE${normalizedRuc}${normalizedPeriodo}00080400001111.${extension}`;
  }

  return `${normalizedTipo}_${normalizedRuc}_${normalizedPeriodo}.${extension}`;
};
